import { createFileRoute } from '@tanstack/react-router';
import { ReferrerEditSheet } from '@/pages/referrers/form';

/**
 * Rotta statica `edit/$id`, sorella di `new` e di `$id`: un indirizzo che non
 * è né `new` né `edit/$id` né un id finisce nel dettaglio, che lo dice non
 * trovato.
 */
export const Route = createFileRoute(
  '/admin/_layout/referrers/_layout/edit/$id'
)({
  component: ReferrerEditRoute,
});

function ReferrerEditRoute() {
  const { id } = Route.useParams();

  return <ReferrerEditSheet id={id} />;
}
